import { z } from 'zod';
export const ApiKeyScopeSchema = z.enum([
    'evidence:write',
    'status:read',
    'results:read',
]);
export const ApiKeyInputSchema = z
    .object({
    name: z.string().trim().min(1).max(100),
    scopes: z
        .array(ApiKeyScopeSchema)
        .min(1)
        .max(3)
        .transform((values) => [...new Set(values)]),
    expiresAt: z.string().datetime({ offset: true }).nullable(),
})
    .strict();
export const ApiKeySchema = ApiKeyInputSchema.extend({
    id: z.string().uuid(),
    orgId: z.string().uuid(),
    tenant: z.string(),
    maskedToken: z.string(),
    version: z.number().int(),
    status: z.enum(['active', 'expired', 'revoked']),
    createdAt: z.string(),
    updatedAt: z.string(),
    revokedAt: z.string().nullable(),
    lastCalledAt: z.string().nullable(),
});
export const ApiKeysPageSchema = z.object({
    items: z.array(ApiKeySchema),
    org: z.object({ id: z.string(), name: z.string(), tenant: z.string() }),
    encryptionConfigured: z.boolean(),
    retentionDays: z.number().int(),
});
export const ApiActivitySchema = z.object({
    requestId: z.string(),
    keyId: z.string().nullable(),
    keyName: z.string().nullable(),
    keyVersion: z.number().nullable(),
    method: z.string(),
    endpoint: z.string(),
    projectId: z.string().nullable(),
    submissionId: z.string().nullable(),
    runId: z.string().nullable(),
    httpStatus: z.number().nullable(),
    durationMs: z.number().nullable(),
    response: z.unknown(),
    error: z.unknown(),
    startedAt: z.string(),
    finishedAt: z.string().nullable(),
});
export const ApiActivityPageSchema = z.object({
    items: z.array(ApiActivitySchema),
    total: z.number(),
});
export const ApiAdminEventSchema = z.object({
    id: z.string(),
    keyId: z.string().nullable(),
    keyName: z.string().nullable(),
    actorEmail: z.string(),
    actorUserId: z.string(),
    action: z.string(),
    details: z.unknown(),
    requestId: z.string(),
    createdAt: z.string(),
});
export const ApiAdminEventsPageSchema = z.object({
    items: z.array(ApiAdminEventSchema),
    total: z.number(),
});
export const ApiHistoryQuerySchema = z
    .object({
    keyId: z.string().uuid().optional(),
    projectId: z
        .string()
        .regex(/^\d{1,24}$/)
        .optional(),
    requestId: z.string().uuid().optional(),
    from: z.string().datetime({ offset: true }).optional(),
    to: z.string().datetime({ offset: true }).optional(),
    outcome: z.enum(['success', 'failure']).optional(),
    offset: z.coerce.number().int().min(0).max(100000).default(0),
    limit: z.coerce.number().int().min(1).max(100).default(50),
})
    .refine((q) => !q.from || !q.to || Date.parse(q.from) <= Date.parse(q.to), 'Start must precede end.');
